import React, { useState } from 'react';

function CartImage({ src, alt, imgClass = 'mProImg' }) {
  const [imgError, setImgError] = useState(false);

  if (imgError) {
    return (
      <div className="mProImgFallback mProImg">
        {/* You can put an SVG icon or initials here */}
        <svg width="24" height="24" fill="#fff"><circle cx="12" cy="12" r="10" fill="#bbb" /></svg>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={imgClass}
      onError={() => setImgError(true)}
    />
  );
}

export default CartImage;